import loginModel from '../../../../models/login.model';
import taskMasterModel from '../../../../models/task-management/task-master.model';
import languageModel from '../../../../models/language.model';
import { Dialog, Spinner, Button, Icons } from 'construct-ui';
import ViewBase from '../../../view-base.view';
import { messageComponent } from '../../../../components/message/message.component';

export default function TaskMasterLinkView() {

    ViewBase.call(this);
    let inputDatModel = {name:"",selectedMenu:"",menuList:[]};
    let countryID = 0;
    let userLanguageCode="EN";
    let isLoading = false;
    let isMsgOpen = false;
    let showMsg = "";
    let msgTitle = "";

    let announcementId="";
    let detailType="";
    let getName = (e) => {
        inputDatModel.name = e.target.value;
    }


    let _clearFilter = () => {
        inputDatModel.name = "";
        _initControls();
    }

    let _search = () => {
        inputDatModel.pageIndex = 1;
        _loadMenuList();
    }

    let _loadMenuList = () => {
     
        taskMasterModel.getMenuMasterList(
            (result)=>{
                isLoading = false;
               
                inputDatModel.menuList = result;
            },
            (error)=>{
                isLoading = false;
                this.handleError(error);
                // isMsgOpen = true;
                // showMsg = error.response[0].transStatus;
                // msgTitle = this.getText(error.response[0].code);
            },
            announcementId,detailType,inputDatModel.pageIndex,inputDatModel.pageSize,inputDatModel.name
        )
    }

    let _initControls = () => {
        _loadMenuList();
    }

    let onPageSizeChanged = (pageIndex, pageSize) => {
        inputDatModel.pageIndex = pageIndex;
        inputDatModel.pageSize = pageSize;
        _loadMenuList();
    }

    let onPageChanged = (pageIndex) => {
        inputDatModel.pageIndex = pageIndex;
        _loadMenuList();
    }


    let _onClosed = (e) => {}
    let _onSaved = (e) => {}
    let _dialogClosed = () => {
        isMsgOpen = false;
    }
    let _save=()=>{
        
        _onSaved(inputDatModel.selectedMenu);
    }
    return {
        oninit: (vnode) => {
            // console.log("oninit");
            countryID = loginModel.credentials.country;
            userLanguageCode = loginModel.credentials.language;
            if (vnode.attrs.onClosed) {
                _onClosed = vnode.attrs.onClosed;
            }
            if (vnode.attrs.onSaved) {
                _onSaved = vnode.attrs.onSaved;
            }
            if (vnode.attrs.selectedMenu) {
                inputDatModel.selectedMenu = vnode.attrs.selectedMenu;
            }
            // _getActivePromotionsList();
            _initControls();
        },
        oncreate: (vnode) => {
            console.log("oncreate");
     

        },
        onupdate: (vnode) => {
            if (countryID != loginModel.credentials.country) {
                countryID = loginModel.credentials.country;
                userLanguageCode = loginModel.credentials.language;
                _clearFilter();
            }
            if(vnode.attrs.statusSelectionNeed && vnode.attrs.statusSelectionNeed=='N'){
                if (detailType != vnode.attrs.detailType) {
                    detailType = vnode.attrs.detailType;
                    _initControls();
                }
            }
          
          
            
        },
        view: (vnode) => {
            return [
                m('.row', 
                    m(Spinner, {
                        active: isLoading,
                        background: true,
                        fill: true,
                        size: 'xl',
                    }
                    ),
                    m('.col-md-12',
                        m('.d-flex.justify-content-end.mb-2', 
                            m('a.btn.btn-outline-primary.btn-search[data-bs-toggle="collapse"][href="#showSearchBarRc"][role="button"][aria-controls="showSearchBar"][aria-expanded="false"]', 
                                m('span.search-arrow.me-2', 
                                    m('i.bi.bi-search')
                                ), languageModel.getText("LT00000001", "Search")
                            )
                        ),
                        m('.card mb-3.searchbox.collapse[id="showSearchBarRc"]', 
                            m('.card-body.py-3', 
                                m('.row', 
                                    m('.container', 
                                        m('.row',
                                            m('.col-md-6', 
                                                m('label.form-label', languageModel.getText("LT00000085", "Menu Name")), 
                                                m('input[type=text][placeholder=' + languageModel.getText("LT00000085", "Menu Name") + '][value="' + inputDatModel.name + '"].form-control.form-control-bg', { onchange: getName }
                                                )               
                                            ),
                                            m('.col-md-6.gap-2.d-sm-flex.mt-4', 
                                                m('button.btn.btn-primary.px-4.gap-3', { onclick: _search }, languageModel.getText("LT00000001", "Search")),
                                                m('button.btn.btn-white.px-4.gap-3', { onclick: _clearFilter }, languageModel.getText("LT00000031", "Clear")),
                                            ),

                            
                        )))),
                       
                        ),
                        m('.card',
                            m('.card-body',
                             
                                m(".table-responsive.menu-link-table-height",
                                    m("table.table",
                                        [
                                            m("tbody",
                                            inputDatModel.menuList.length == 0 &&
                                                m("tr", { "class": "align-middle" },
                                                    m("td", { "colspan": "7" }, languageModel.getText("EM00000141", "No records found."))
                                                ),
                                                inputDatModel.menuList.map(gc =>
                                                    [
                                                        m("tr",
                                                         
                                                        {"class":inputDatModel.selectedMenu !=[] && gc["menuID"]==inputDatModel.selectedMenu["menuID"]?"rowSelected":"rowSelect",onclick:()=>{
                                                            if(inputDatModel.selectedMenu!=[] && inputDatModel.selectedMenu["menuID"]==gc["menuID"]){
                                                                inputDatModel.selectedMenu=[];
                                                            }
                                                            else{
                                                                inputDatModel.selectedMenu=gc;
                                                            }
                                                            
                                                        }}, m("td", gc.name))
                                                    ]),
                                            )
                                        ]
                                    )
                                )
                               // , !isLoading && m(paginationComponent, { currentPage: inputDatModel.pageIndex, pageSize: inputDatModel.pageSize, totalItems: inputDatModel.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged }) 
                            ),
                            m('.card-footer',
                            m('.col-md-12 .gap-2 .d-flex .justify-content-end',
                                m(
                                    "button.btn.btn-primary[type='button']", { onclick: _save },
                                    this.getText("LT00000022", "Save")
                                ),
                                m(
                                    "button.btn.btn-white[type='button']", { onclick: ()=>{
                                        _onClosed();
                                    } },
                                    this.getText("LT00000021", "Close")
                                )
                            )
                        )
                        )
                    ),
                    m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed })
                ),
                this.getBaseViews()
            ]
        }
    }
}
